import { z } from 'zod';

// Legacy module — re-exports the v3 page-layout schema under the old name
// (`homepageLayoutSchema`) so callers don't need an immediate import rename.
// Picker query schema stays here since it's still used by the group-content
// article picker route (unrelated to layout shape).

export { pageLayoutSchema as homepageLayoutSchema } from './page-layout';
export type { PageLayoutInput as HomepageLayoutInput } from './page-layout';

/* ---------- Picker query (post search) ---------- */

export const homepagePickerQuerySchema = z.object({
  q: z.string().trim().max(80).optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type HomepagePickerQuery = z.infer<typeof homepagePickerQuerySchema>;
